// eslint-disable-next-line @typescript-eslint/no-explicit-any

export let OAuthProvider = /*#__PURE__*/function (OAuthProvider) {
  OAuthProvider["Intuit"] = "intuit";
  OAuthProvider["Google"] = "google";
  OAuthProvider["Xero"] = "xero";
  return OAuthProvider;
}({});
export let BusinessPartyTypeEnum = /*#__PURE__*/function (BusinessPartyTypeEnum) {
  BusinessPartyTypeEnum["MultiVendorCustomer"] = "multiVendorCustomer";
  BusinessPartyTypeEnum["Customer"] = "customer";
  BusinessPartyTypeEnum["Vendor"] = "vendor";
  return BusinessPartyTypeEnum;
}({});
export let BusinessIndustryType = /*#__PURE__*/function (BusinessIndustryType) {
  BusinessIndustryType["Accounting"] = "accounting";
  BusinessIndustryType["Bookkeeping"] = "bookkeeping";
  BusinessIndustryType["TaxRepresentation"] = "tax";
  BusinessIndustryType["TaxPreparation"] = "tax_preparation";
  BusinessIndustryType["TaxResolution"] = "tax_resolution";
  BusinessIndustryType["Marketing"] = "marketing";
  BusinessIndustryType["Other"] = "other";
  return BusinessIndustryType;
}({});
export let PayoutBankAccountType = /*#__PURE__*/function (PayoutBankAccountType) {
  PayoutBankAccountType["Connected"] = "connected";
  PayoutBankAccountType["NotConnected"] = "notConnected";
  return PayoutBankAccountType;
}({});
export const isBankAccountConnected = account => !!account && account.type === PayoutBankAccountType.Connected;
export let KycCompletionStatus = /*#__PURE__*/function (KycCompletionStatus) {
  KycCompletionStatus["InitialIncomplete"] = "initialIncomplete";
  KycCompletionStatus["AwaitingCompletion"] = "awaitingCompletion";
  KycCompletionStatus["Completed"] = "completed";
  KycCompletionStatus["Incomplete"] = "incomplete";
  KycCompletionStatus["CompletedWithFutureRequirements"] = "completedWithFutureRequirements";
  return KycCompletionStatus;
}({});